export const HEADINGS = [
  ["name", "Name"],
  ["status", "Status"],
];

export const searchMap = {
  Name: "name",
};
